module.exports = __webpack_public_path__ + "b83d2d3a1db702a06a8bfb1555b9d6b5.jpg";